import { useFocusEffect, useNavigation } from "@react-navigation/native";
import {
  StockCount,
  StockCountStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { FlatListSearchableSkeleton } from "../../../../../../components/FlatListSearchableSkeleton";
import { STOCK_COUNTS } from "../../../../../../utilities/stock-count";
import { useLoadMoreList } from "../../../../../../utilities/load-more-list";
import React from "react";
import { useScheduler } from "../../../../../../utilities/scheduler";
import { useSearchQueryProvider } from "../../../../../../utilities/search";
import { StockCountResourceList } from "../../../../components/StockCountResourceList";
import { useListFilterContext } from "../../../../../../utilities/list-filter/use-list-filter-context";
import { InvoiceArrivalFilterValues } from "../../../../../invoice-arrival/types";
import { filterValuesToApiInput } from "../../../../common";

export interface StockCompletedListTabProps {}

export function StockCompletedListTab(props: StockCompletedListTabProps) {
  const navigation = useNavigation<any>();
  const { schedule } = useScheduler(500);
  const search = useSearchQueryProvider();
  const { watch } = useListFilterContext<InvoiceArrivalFilterValues>();
  const watchedFilterValues = watch();

  const loadMoreList = useLoadMoreList<StockCount>({
    initialLoad: false,
    query: STOCK_COUNTS,
    resultKey: "stockCounts",
    sort: { updatedAt: "DESC" },
    variableFormatter: (variables) => {
      return {
        options: {
          ...variables,
          filter: {
            ...variables.filter,
            status: { eq: StockCountStatus.COMPLETE },
          },
        },
      };
    },
  });

  useFocusEffect(
    React.useCallback(() => {
      handleLoadMore(true);
    }, [watchedFilterValues])
  );

  React.useEffect(() => {
    if (loadMoreList.called) {
      schedule(() => {
        handleLoadMore(true);
      });
    }
  }, [search.query]);

  const handleLoadMore = (reset?: boolean) => {
    loadMoreList.loadMore(
      {
        filter: {
          ...filterValuesToApiInput(watchedFilterValues),
        },
      },
      reset
    );
  };

  const items: StockCount[] = loadMoreList.items || [];

  function handleStockCountPress(stockCount: StockCount) {
    navigation.navigate("StockCountCompletedRootScreen", {
      stockCountId: stockCount.id,
    });
  }

  if (loadMoreList.loading && loadMoreList.items.length == 0) {
    return <FlatListSearchableSkeleton searchbar={false} />;
  }
  return (
    <StockCountResourceList
      items={items}
      onEndReached={() => handleLoadMore(false)}
      onPressAll={(item) => handleStockCountPress(item)}
    />
  );
}
